import api from "./api";
import config from "../config";

export default {
  fetchAll(person) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `people/self/tickets`,
          qs: {
            token: person,
            conditions: { event_bucket: config.event_bucket }
          }
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.tickets);
        }
      );
    });
  },

  fetchOne(person, ticket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `tickets/${ticket}`,
          qs: { token: person }
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/TicketFetcher.js